import { buildSchema, buildProperty, ExportMappingFunction } from "@camberi/firecms";

/**
 * This is a schema that is generated without passing an explicit type,
 * but it is inferred correctly since we are using `buildProperty` in each property
 */
export const inAppProductsSchema = buildSchema({
    name: "In App Products",
    properties: {
        title: buildProperty({
            title: "Title",
            validation: { required: true },
            dataType: "string"
        }),
        sub_description: buildProperty({
            title: "Sub Description",
            validation: { required: true },
            dataType: "string"
        }),
        description: buildProperty({
            title: "Description",
            validation: { required: true },
            dataType: "string"
        }),
        productId: buildProperty({
            title: "Product Id",
            validation: { required: true },
            dataType: "string",
        }),
        currency: buildProperty({
            title: "Currency",
            validation: { required: true },
            dataType: "string",
            config: {
                enumValues: {
                    GBP: "GBP",
                    USD: "USD",
                }
            }
        }),
        price: buildProperty({
            title: "Price",
            validation: { required: true },
            dataType: "number",
        }),
        type: buildProperty({
            title: "Type",
            validation: { required: true },
            dataType: "string",
            config: {
                enumValues: {
                    SUBSCRIPTION: "SUBSCRIPTION",
                }
            }
        }),
        thumbnail: buildProperty({
            title: "Thumbnail",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
            validation: { required: true },
        }),
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            columnWidth: 250,
            validation: { required: true },
        },
    },
    defaultValues: {
        event: "onGeneralMessage"
    }
});

/**
 * Sample field that will be added to the export
 */
export const sampleAdditionalExportColumn: ExportMappingFunction = {
    key: "extra",
    builder: async ({ entity }) => {
        await new Promise(resolve => setTimeout(resolve, 100));
        return "Additional exported value " + entity.id;
    }
};
